<ng-template #ReceiptHeader>
	<!-- Receipt-Header -->
	<div class="grid-1-auto app-space-top" *ngIf="!workspace.isLoading">
		<h2 class="app-space-left">
			<i [ngClass]="getRessource('ReceiptIcon')"
			   class="app-space-right">
			</i>
			{{getGlobal('Receipt') + '&nbsp;' + (VCreceipt.receipt?.rcptNumber ? '-&nbsp;' + VCreceipt.receipt?.rcptNumber : '')}}
			<i class="far fa-exclamation-triangle c-yellow"
			   *ngIf="workspace.duplicates.length > 0 && excSecurity.isFeatured('RECEIPTCHECKDUPL')"
			   [tooltip]="getRessource('Tooltip.checkDuplicates')"
				 (click)="showModalReceiptCheckDuplicate()">
			</i>
		</h2>
		<div class="typo-small typo-right app-space-top app-space-right">
			<em>
				{{enumSvc.getEnumerationText('ReceiptStatus', workspace.receiptData.rcpt_enmIdent_ReceiptStatus)}}
			</em>
			<em>
				{{enumSvc.getEnumerationText('ReceiptType', workspace.receiptData.rcpt_enmIdent_ReceiptType)}}
			</em>
		</div>
		<div class="grid-auto-1-auto app-space-top">
      <span class="typo-small">
        {{enumSvc.getFieldCaption('Receipt','rcptComp')}}:
      </span>
			<span><strong>{{workspace.company?.compName}}</strong></span>
			<span></span>
			<span class="typo-small"
			      style="padding-top: 15px">
				{{getRessource('openNetto')}}
			</span>
			<span style="padding-left: 8px">
				{{openSum | excCurrency:'EUR'}}
				<i class="search-filter-action fal fa-check typo-small"
				   style="font-size: 20px"
				   [tooltip]="'Differenzbetrag freigeben'"
				   [class.disabled]="!(openSum > 0 || securityHandler.canEdit())"
				   (click)="addOpenSumPosition()"></i>
				<i class="search-filter-action fal fa-xmark typo-small"
				   style="font-size: 20px"
				   [tooltip]="'Differenzbetrag ablehnen'"
				   [class.disabled]="!(openSum > 0 || securityHandler.canEdit())"
				   (click)="addDeclineOpenSumPosition()"></i>
			</span>
			<div class="spawn-reverse">
				<i  class="search-filter-action"
				    style="font-size: 20px; border-radius: 30%; margin-right: 12px"
				    [tooltip]="'Regulierungsverinbarung'"
				    [class.disabled]="!securityHandler.canEdit() || aiRunning()"
				    (click)="receiptFinishRV()">
					RV
				</i>
			</div>
		</div>
		<div class="typo-small typo-right app-space-right app-space-top">
			<em class="app-space-bottom"
			    style="padding-top: 30px">
				<strong>{{VCreceipt.receipt?.rcptDate | excDate}}</strong>
			</em>
		</div>
    <div class="typo-container-s-s-q">
    </div>
	</div>
</ng-template>
<ng-template #LoadingSpinner>
	<i class="far fa-spinner-third fa-spin app-space-right" *ngIf="workspace.isLoadingPreview"></i>
</ng-template>
<div class="content grid-1-auto md3-surface">
  <div class="content md3-card-on-surface">
    <app-exc-pdfviewer-v3 *ngIf="!workspace.hideViewer"
		                      [docPath]="viewerurl"
	                        [docID]="workspace.receiptData.rcptID"
	                        [docName]="workspace.receiptData.rcptFileName"
	                        [docAnnotations]="workspace.receiptData.AggrAnnotation"

                          [showAnnotationToolbar]="true"
	                        [canShowAnnotationToolbar]="(
				                      VCrightTabControl._selectedtab !== 0
				                      && VCrightTabControl._selectedtab !== 3
			                      ) && securityHandler.canEdit()"

	                        (viewerDocumentLoaded)="receiptPDFViewer.onDocumentLoaded()"
	                        (viewerPageClicked)="receiptPDFViewer.pageClicked()"
	                        (ready)="receiptPDFViewer.onViewerReady()"

	                        (annotationAdded)="receiptPDFViewer.annotationAdded($event)"
	                        (annotationDeleted)="receiptPDFViewer.annotationDeleted($event)"
	                        (annotationPropertiesChanged)="receiptPDFViewer.annotationChanged($event)"
	                        (annotationChanged) = "receiptPDFViewer.annotationChanged($event)"
	                        (annotationUnselected)="receiptPDFViewer.annotationUnselected($event)"
	                        (annotationSelected)="receiptPDFViewer.annotationSelected($event)"

	                        (annotationModeChanged)="receiptPDFViewer.annotationModeChanged($event)"

	                        (signatureSelect)="receiptPDFViewer.signatureSelect($event)"
	                        (signatureUnSelect)="receiptPDFViewer.signatureUnSelect($event)"

	                        [showOnlyStamps]="VCrightTabControl.selectedtab === 1"
	                        [userStempel]="userSettingsSvc.stempel"

                          [hidden]="!workspace.receiptData">
    </app-exc-pdfviewer-v3>
  </div>
  <div class="content md3-card-on-surface">
    <div class="app-layout-frame-drawer" style="width: 660px" #DivDrawer>
      <div class="content">
        <app-exg-tab-v2 #VCrightTabControl (tabchange)="rightTabs_tabChange($event)"
                        [header]="rightTabs"  [hidden]="workspace.isLoading">
          <ng-template #pages>
            <!-- 1 - Details-->
	          <div class=" content">
		          <app-receipt #VCreceipt
                           [DataReceipt]=" {
                              receipt: workspace.receiptData,
                              details: details}"
                           [CompanyData]="workspace.company"
                           [checkview]="this"
                           [canChangeEditMode]="securityHandler.canEdit()">
                <!--set von Data Details in loadCheckview-->
              </app-receipt>
            </div>
            <!-- 2 - Positions -->
            <div class="content">
              <div class="app-layout-annotation app-space-left" [hidden]="workspace.isLoading">
	              <ng-container *ngTemplateOutlet="ReceiptHeader"></ng-container>

	              <!-- Annotation     -->
                <div class="app-space-top app-space-bottom ">
                  <app-annotation-correction #VCCorrectionAnnotation
                                             [correction]="receiptCorrectionTable.selectedRow"
                                             [hidden]="visibilityController.correction">
                  </app-annotation-correction>
                </div>
	              <div class="search-filter-seperator"></div>
                <!-- Corrections -->
                <div class="content app-subarea app-nospace" >
                  <exg-data-list #VCreceiptCorrectionTable
                                  (RowChange)="receiptCorrectionTable.selectionChanged($event);"
                                  (dblclick)="visibilityController.correctionSwitch(VCreceiptCorrectionTable.selectedRow === -1 || !securityHandler.canEdit())"
                                  [allowSingleSelection]="true"
                                  [displayState]="receiptCorrectionTable.state"
                                  [rowSource]="receiptCorrectionTable.data"
                                  [selectKey]="receiptCorrectionTable.selectKey">
                    <ng-template #rowTemplate let-row>
	                    <div class="list-row list-row-1-auto app-list typo-small">

		                    <div class="grid-auto-1">
			                    <p *ngIf="row.inputValuesCount >= 2">
				                    <i *ngIf="row.inputBlock" class="fa-duotone fa-bars"></i> {{row.inputValuesCount}}
			                    </p>
			                    <div>
				                    <p>
					                    <strong>{{row.rcptCorTitle && row.rcptCorTitle.length > 0 ? row.rcptCorTitle : ''}}</strong>
				                    </p>
			                    </div>
		                    </div>
		                    <div class="typo-right">
			                    <div class="list-metadata">{{row.rcptAnnoCRD | excDate}}, {{row.rcptAnnoCRU}}</div>
		                    </div>
		                    <div class="">
			                    <p class="">{{row.rcptCorDesc}}</p>
		                    </div>
		                    <div class="grid-1-auto">
			                    <p class="typo-right">
				                    {{ 1 * row.rcptCorAmountOrig | excCurrency:'€'}}
			                    </p>
			                    <p [class.c-red]="row.rcptCorAmountCorr < 0" [class.c-green]="row.rcptCorAmountCorr > 0">
				                    {{row.rcptCorAmountCorr | excCurrency:'€'}}
			                    </p>
		                    </div>
	                    </div>
                    </ng-template>
                  </exg-data-list>
                </div>
                <div class="typo-container-q-s-s app-space-right app-space-top_1p5 search-filter-seperator">
                  <q></q>
                  <span>{{getRessource('lineup.PassingValue')}}:</span>
                  <span>
                    <strong>
                        {{receiptCorrectionTable.getCorrSumme(1) | excCurrency:'€'}}
                    </strong>
                  </span>
                </div>
                <!-- Summierungen | Aufrechnung-->
	              <div class="app-space-bottom">
		              <exg-panel caption="Summierungen | Aufrechnung">
			              <ng-template #content>
				              <div class="grid-1-auto-auto" *ngIf="!workspace.isLoading">
					              <div class="typo-container-q-s-s app-space-right app-space-top">
						              <q></q>
						              <span class="typo-center "></span>
						              <span class="typo-right  "></span>

						              <q></q>
						              <span class="typo-right  app-space-top_1p5"></span>
						              <span class="typo-right  app-space-top_1p5 app-seperator-right">
							              {{enumSvc.getFieldCaption("Receipt", "rcptNetSum")}}
													 </span>

						              <q></q>
						              <span class="typo-small app-space-top"></span>
						              <span class="typo-right typo-small app-space-top app-seperator-right">
			                      {{enumSvc.getFieldCaption('Receipt','rcptVATRate') + '&nbsp;[' + VCreceipt.receipt?.rcptVATRate + '%]'}}
			                    </span>

						              <q></q>
						              <span class="app-space-top app-space-top_1"></span>
						              <span class="typo-right app-space-top_1 search-filter-seperator app-seperator-right_transparent">
			                      <strong>
				                      {{enumSvc.getFieldCaption("Receipt", "rcptGrossSum")}}
			                      </strong>
			                    </span>
					              </div>
					              <div class="typo-container-q-s-s app-space-right app-space-top">
						              <q></q>
						              <span class="typo-right typo-small">
			                      <strong>{{getRessource('lineup.ReceiptValue')}}</strong>
			                    </span>
						              <span class="typo-right typo-small">
			                      <strong>[{{getRessource('lineup.detected')}}]</strong>
			                    </span>

						              <q></q>
						              <span class="typo-right app-space-top_1 ">
			                        {{workspace.reviewPreCalc.receiptNetto | excCurrency:'€'}}
			                    </span>
						              <span class="typo-right app-space-top_1 ">
			                      {{  workspace.reviewPreCalc.originalNetto  | excCurrency:'€' }}
			                    </span>

						              <q></q>
						              <span class="typo-right typo-small app-space-top">
			                      {{workspace.reviewPreCalc.receiptVat | excCurrency:'€'}}
			                    </span>
						              <span class="typo-right typo-small app-space-top">
			                      {{  workspace.reviewPreCalc.originalVat | excCurrency:'€' }}
			                    </span>

						              <q></q>
						              <span class="typo-right  app-space-top_1p5 search-filter-seperator">
							              <strong>
								              {{ workspace.reviewPreCalc.receiptBrutto | excCurrency:'€'}}
							              </strong>
						              </span>
						              <span class="typo-right  app-space-top_1p5 search-filter-seperator">
			                      {{ workspace.reviewPreCalc.originalBrutto| excCurrency:'€' }}
			                    </span>
					              </div>
					              <div class="typo-container-q-s-s app-space-right app-space-top">
						              <q></q>
						              <span class="typo-right typo-small">
			                      <strong>
				                      [{{getRessource('lineup.Corrections')}}]
			                      </strong>
						              </span>
						              <span class="typo-right typo-small">
			                      <strong>
				                      [{{getRessource('lineup.Passing')}}]
			                      </strong>
			                    </span>

						              <q></q>
						              <span class="typo-right app-seperator-left app-space-top_1 "
						                    [ngClass]="{'c-green': workspace.reviewPreCalc.resultNetto < 0,
	                                     'c-red': workspace.reviewPreCalc.resultNetto > 0}">
			                      {{(-1 * workspace.reviewPreCalc.resultNetto) | excCurrency:'€' }}
			                    </span>
						              <span class="typo-right app-space-top_1">
			                      {{workspace.reviewPreCalc.sumCorrNetto | excCurrency:'€'}}
			                    </span>

						              <q></q>
						              <span class="typo-right typo-small app-space-top app-seperator-left"
						                    [ngClass]="{'c-green': workspace.reviewPreCalc.resultVAT < 0,
	                                       'c-red': workspace.reviewPreCalc.resultVAT > 0}">
			                      {{(-1 * workspace.reviewPreCalc.resultVAT) | excCurrency:'€' }}
			                    </span>
						              <span class="typo-right typo-small  app-space-top ">
			                      {{workspace.reviewPreCalc.sumCorrVat | excCurrency:'€'}}
			                    </span>

						              <q></q>
						              <span class="typo-right app-space-top_1p5 search-filter-seperator"
						                    [ngClass]="{'c-green': workspace.reviewPreCalc.resultBrutto < 0,
	                                       'c-red': workspace.reviewPreCalc.resultBrutto > 0}">
                            {{(-1 * workspace.reviewPreCalc.resultBrutto) | excCurrency:'€' }}
			                    </span>
						              <span class="typo-right app-space-top_1p5 search-filter-seperator">
			                      <strong>
				                      {{workspace.reviewPreCalc.sumCorrBrutto | excCurrency:'€'}}
			                      </strong>
			                    </span>
					              </div>
				              </div>
			              </ng-template>
		              </exg-panel>
	              </div>
              </div>
            </div>
            <!-- 3 - Notes-->
	          <div class="content">
		          <div [hidden]="workspace.isLoading" class="app-layout-annoation-notes app-space-left">
			          <ng-container *ngTemplateOutlet="ReceiptHeader"></ng-container>
			          <div class="app-space-top app-space-bottom ">
				          <app-annotation-text #VCTextAnnotation
				                               [note]="receiptNoteTable.selectedRow"
				                               [hidden]="visibilityController.note">
				          </app-annotation-text>
			          </div>
			          <div class="search-filter-seperator"></div>
			          <!-- Notes-->
			          <div class="content app-subarea">
				          <exg-data-list  #VCreceiptNoteTable
				                          (RowChange)="receiptNoteTable.selectionChanged($event)"
				                          (dblclick)="visibilityController.noteSwitch(VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit())"
				                          [displayState]="receiptNoteTable.state"
				                          [rowSource]="receiptNoteTable.data"
				                          [selectKey]="receiptNoteTable.selectKey"
				                          [allowSingleSelection]="true">
					          <ng-template #rowTemplate let-row>
						          <div class="list-row list-row-1-auto app-list typo-small">
							          <div>
								          <p>
									          {{row.rcptNtsNote}}
								          </p>
							          </div>
							          <div class="typo-right">
								          <div class="list-metadata">{{row.rcptAnnoCRD | excDate}}, {{row.rcptAnnoCRU}}</div>
							          </div>
						          </div>
					          </ng-template>
				          </exg-data-list>
			          </div>
		          </div>
	          </div>
            <!-- 4 - Details-->
	          <div class=" content">
		          <div class="layout-auto-1 app-space-left app-space-right">
			          <ng-container *ngTemplateOutlet="ReceiptHeader"></ng-container>
			          <!-- Review -->
			          <app-receipt-review #VCreceiptReview
		                                [canEdit]="securityHandler.canEdit()"
		                                [workspace]="workspace"
			                              [details]="details"
		                                [checkview]="this">
		            </app-receipt-review>
			          <!-- Review Buttons -->
			          <div class="spawn-reverse typo-small">
				          <ng-container *ngIf="VCreceiptReview && !VCreceiptReview?.reviewEditMode">
					          <button (click)="receiptShowPreviewModal()"
					                  class="md-btn" [disabled]="workspace.isLoadingPreview">
						          <ng-container *ngTemplateOutlet="LoadingSpinner"></ng-container> {{getRessource('preview')}}
					          </button>
					          <button (click)="receiptReviewU_RevokeState(getRessource(isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [10,20]) ? 'revokeAgain' : 'revoke'))"
					                  *ngIf="workspace.receiptData && workspace.receiptData.rcpt_enmIdent_ReceiptStatus &&
					                          ((isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [3,10,20]) && securityHandler.powerUser())
					                           || (isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [3]) && !securityHandler.powerUser()))"
					                  class="md-btn">
						          {{getRessource(isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [10,20]) ? 'revokeAgain' : 'revoke')}}
					          </button>
					          <button (click)="pickReview()"
					                  [class.disabled]="!securityHandler.canPick()"
					                  *ngIf="securityHandler.canPick()"
					                  class="md-btn">
						          {{getRessource('Pick')}}
					          </button>
					          <ng-container #SV *ngIf="isOneOf(workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [0,1,2,5])">
						          <button (click)="receiptReview(getRessource('review.proofIt'), true, undefined)"
						                  class="md-btn" [disabled]="VCreceiptReview.conditions.canChangeState()">
							          {{getRessource('review.proofIt')}}
						          </button>
					          </ng-container>
					          <ng-container #IIS *ngIf="excSecurity.isFeatured('RECEIPTCHECK') && workspace.receiptData.rcpt_enmIdent_ReceiptStatus === 4">
						          <button (click)="receiptReview(getRessource('review.toSV'), true, undefined)"
						                  class="md-btn">
							          {{getRessource('review.toSV')}}
						          </button>
						          <button (click)="receiptReview(getRessource('review.cancel'), true, false)"
						                  class="md-btn app-space-left"
						                  [disabled]="VCreceiptReview.conditions.canChangeState()">
							          {{getRessource('review.cancel')}}
						          </button>
						          <button (click)="receiptReview(getRessource('review.accept'), true, true)"
						                  class="md-btn"
						                  [disabled]="VCreceiptReview.conditions.canChangeState()">
							          {{getRessource('review.accept')}}
						          </button>
					          </ng-container>
				          </ng-container>
			          </div>
	            </div>
	          </div>
          </ng-template>
        </app-exg-tab-v2>
	      <!-- loading Drawer -->
	      <div *ngIf="workspace.isLoading" class="splash loading">
		      <div class="spinner">
			      <div></div>
			      <div></div>
			      <div></div>
			      <div></div>
		      </div>
	      </div>
      </div>
	    <!-- Right Quickactions -->
	    <div class="app-drawer">
		    <i class="disabled search-filter-action"></i>
		    <i class="search-filter-seperator"></i>
		    <ng-container *ngIf="!workspace.isLoading">
			    <!-- Quickactions - 1 -->
			    <ng-container *ngIf="VCreceipt && (VCrightTabControl?.selectedtab === 0 || VCrightTabControl?.selectedtab === 3)">
				    <ng-container *ngIf="VCrightTabControl?.selectedtab === 0">
					    <ng-container *ngIf="!VCreceipt?.receiptEditMode">
						    <i (click)="VCreceipt?.switchEditMode(this.securityHandler.canEdit())"
						       [class.disabled]="!securityHandler.canEdit() || aiRunning()" [tooltip]="getGlobal('Edit')"
						       class="search-filter-action fal fa-edit" flow="left">
						    </i>
					    </ng-container>
					    <ng-container *ngIf="VCreceipt?.receiptEditMode && !VCreceipt.visibilityController.companyForm">
						    <i (click)="showMessageSureAbout()"
						       [tooltip]="getGlobal('Cancel')"
						       class="search-filter-action fal fa-window-close" flow="left">
						    </i>
						    <i (click)="saveReceipt(false)"
						       [class.disabled]="!VCreceipt?.rcptChanged || workspace.isLoading || aiRunning()"
						       [tooltip]="getGlobal('Save')"
						       class="search-filter-action fal fa-save" flow="left">
						    </i>
						    <i class="search-filter-seperator"></i>
					    </ng-container>
				    </ng-container>
				    <ng-container *ngIf="VCrightTabControl?.selectedtab === 3">
					    <ng-container *ngIf="!VCreceiptReview?.reviewEditMode">
						    <i (click)="VCreceiptReview?.switchEditMode(this.securityHandler.canEdit())"
						       [class.disabled]="!securityHandler.canEdit() || aiRunning()"
						       [tooltip]="getGlobal('Edit')"
						       class="search-filter-action fal fa-edit" flow="left">
						    </i>
					    </ng-container>
					    <ng-container *ngIf="VCreceiptReview?.reviewEditMode">
						    <i (click)="showMessageSureAbout()"
						       [tooltip]="getGlobal('Cancel')"
						       class="search-filter-action fal fa-window-close" flow="left">
						    </i>
						    <i (click)="receiptReviewSave()"
						       [class.disabled]="!VCreceiptReview?.reviewChanged || workspace.isLoading || aiRunning()"
						       [tooltip]="getGlobal('Save')"
						       class="search-filter-action fal fa-save" flow="left">
						    </i>
						    <i class="search-filter-seperator"></i>
					    </ng-container>
				    </ng-container>
				    <ng-container #References *ngIf="!VCreceipt?.receiptEditMode">
					    <i class="fal fa-folder-tree search-filter-action"
					       [class.disabled]="!workspace.details.caseDetails?.auID || aiRunning()"
					       (click)="OpenReferenceTab()"
					       [tooltip]="getRessource('Tooltip.References')" flow="left"></i>
					    <!-- Quickactions - 1 - Reference -->
					    <i class="fal fa-fw fa-comments search-filter-action"
					       [class.disabled]="!(workspace.isLoading || workspace) || aiRunning()"
					       (click)="receiptOpenMessageModal()"
					       [tooltip]="getRessource('Tooltip.Messages')" flow="left">
						    <i *ngIf="getCommentaryLength > 0" style="font-size: 1.25rem; top: -26px"
						       class="fa-badge" [attr.data-badge]="getCommentaryLength"></i>
					    </i>
					    <i class="search-filter-seperator"></i>
					    <i class="search-filter-action fal fa-file-import"
					       [class.disabled]="!securityHandler.canEdit() || aiRunning() || aiJobRunning()"
					       (click)="OpenFileReplaceModal()"
					       [tooltip]="getRessource('Tooltip.Replace')" flow="left">
					    </i>
					    <i class="search-filter-action fal fa-file-circle-plus"
					       [class.disabled]="!securityHandler.canEdit() || aiRunning() || aiJobRunning()"
					       (click)="OpenFileAddModal()"
					       [tooltip]="getRessource('Tooltip.AddFile')" flow="left">
					    </i>
					    <i class="search-filter-seperator"></i>
<!-- 					    <i class="fa-brands fa-the-red-yeti search-filter-action" -->
<!-- 					       [class.disabled]="!(workspace.isLoading || workspace)" -->
<!-- 					       (click)="receiptRestoreDetails()" -->
<!-- 					       *ngIf="excSecurity.isFeatured('DEVELOPMENT')" -->
<!-- 					       flow="left"> -->
<!-- 					    </i> -->
<!-- 					    <i class="search-filter-seperator" -->
<!-- 					       *ngIf="excSecurity.isFeatured('DEVELOPMENT')"> -->
<!-- 					    </i> -->
				    </ng-container>
				    <ng-container>
					    <!-- Test Report -->
					    <i class="fal fa-clipboard search-filter-action"
					       (click)="openWorkspace()"
					       [tooltip]="getRessource('Tooltip.openTaskWorkspace')" flow="left"></i>
					    <i class="search-filter-seperator"></i>
					    <i class="fal search-filter-action"
					       [class.fa-file-chart-pie]="!(workspace.isLoadingPreview && !visibilityController.taskReportxlsx) || visibilityController.taskReportxlsx"
					       [class.fa-spinner-third]="workspace.isLoadingPreview && !visibilityController.taskReportxlsx"
					       [class.fa-spin]="workspace.isLoadingPreview && !visibilityController.taskReportxlsx"
					       [class.disabled]="!( details.taskDetails !== undefined) || workspace.isLoadingPreview || aiRunning()"
					       (click)="receiptTaskOpenTestReport()"
					       [tooltip]="!(workspace.isLoadingPreview && !visibilityController.taskReportxlsx) ? getRessource('Tooltip.ReportFile', {fileextension: 'xlsx', entity: 'Vorgang'}) : ''" flow="left"></i>
					    <i class="fal search-filter-action"
					       [class.fa-spinner-third]="workspace.isLoadingPreview && !visibilityController.taskReportpdf"
					       [class.fa-file-pdf]="!(workspace.isLoadingPreview && !visibilityController.taskReportpdf) || visibilityController.taskReportpdf"
					       [class.fa-spin]="workspace.isLoadingPreview && !visibilityController.taskReportpdf"
					       [class.disabled]="!( details.taskDetails !== undefined) || workspace.isLoadingPreview || aiRunning()"
					       (click)="receiptTaskOpenTestReportPdf()"
					       [tooltip]="!(workspace.isLoadingPreview && !visibilityController.taskReportpdf) ? getRessource('Tooltip.ReportFile', {fileextension: 'pdf', entity: 'Vorgang'}) : ''" flow="left"></i>
					    <i class="search-filter-seperator"></i>
					    <i class="fal search-filter-action"
					       [class.fa-file-chart-line]="!(workspace.isLoadingPreview && !visibilityController.caseReportxlsx) || visibilityController.caseReportxlsx"
					       [class.fa-spinner-third]="workspace.isLoadingPreview && !visibilityController.caseReportxlsx"
					       [class.fa-spin]="workspace.isLoadingPreview && !visibilityController.caseReportxlsx"
					       [class.disabled]="!( details.caseDetails !== undefined) || workspace.isLoadingPreview || aiRunning()"
					       (click)="receiptCaseOpenTestReport()"
					       [tooltip]="!(workspace.isLoadingPreview && !visibilityController.caseReportxlsx) ? getRessource('Tooltip.ReportFile', {fileextension: 'xlsx', entity: 'Auftrag'}) : ''" flow="left"></i>
					    <i class="fal search-filter-action"
					       [class.fa-file-pdf]="!(workspace.isLoadingPreview && !visibilityController.caseReportpdf) || visibilityController.caseReportpdf"
					       [class.fa-spinner-third]="workspace.isLoadingPreview && !visibilityController.caseReportpdf"
					       [class.fa-spin]="workspace.isLoadingPreview && !visibilityController.caseReportpdf"
					       [class.disabled]="!( details.caseDetails !== undefined) || workspace.isLoadingPreview || aiRunning()"
					       (click)="receiptCaseOpenTestReportPdf()"
					       [tooltip]="!(workspace.isLoadingPreview && !visibilityController.caseReportpdf) ? getRessource('Tooltip.ReportFile', {fileextension: 'pdf', entity: 'Auftrag'}) : ''" flow="left"></i>
<!-- 					    <i class="search-filter-seperator"></i> -->
<!-- 					    <i class="fa-regular search-filter-action" -->
<!-- 					       [class.disabled]="!(details.caseDetails !== undefined) || workspace.isLoadingPreview" -->
<!-- 					       (click)="receiptCaseOpenTestReportPdf()"></i> -->
				    </ng-container>
				    <i class="search-filter-seperator"></i>
			    </ng-container>

			    <!-- Quickactions - Positionen -->
			    <ng-container *ngIf="VCrightTabControl?.selectedtab === 1">
				    <ng-container *ngIf="!visibilityController.correction">
					    <i (click)="receiptCorrection(true)"
					       [tooltip]="getGlobal('Cancel')"
					       class="search-filter-action fal fa-window-close" flow="left">
					    </i>
					    <i (click)="receiptCorrection()"
					       [tooltip]="getGlobal('Save')"
					       class="search-filter-action fal fa-save" flow="left">
					    </i>
				    </ng-container>
				    <ng-container *ngIf="visibilityController.correction">
					    <i (click)="visibilityController.correctionSwitch(VCreceiptCorrectionTable.selectedRow === -1 || !securityHandler.canEdit())"
					       [class.disabled]="VCreceiptCorrectionTable.selectedRow === -1 || !securityHandler.canEdit()"
					       [tooltip]="getGlobal('Edit')"
					       class="search-filter-action fal fa-edit" flow="left">
					    </i>
					    <i (click)="deleteCorrection()"
					       [class.disabled]="VCreceiptCorrectionTable.selectedRow === -1 || !securityHandler.canEdit()"
					       [tooltip]="getGlobal('Delete')"
					       class="search-filter-action fal fa-trash-alt" flow="left">
					    </i>
					    <i class="search-filter-seperator"></i>
				    </ng-container>
			    </ng-container>

			    <!-- Quickactions - Notizen -->
			    <ng-container *ngIf="VCrightTabControl?.selectedtab === 2">
				    <ng-container *ngIf="!visibilityController.note">
					    <i (click)="receiptNote(true)"
					       [tooltip]="getGlobal('Cancel')"
					       class="search-filter-action fal fa-window-close" flow="left">
					    </i>
					    <i (click)="receiptNote()"
					       [tooltip]="getGlobal('Save')"
					       class="search-filter-action fal fa-save" flow="left">
					    </i>
				    </ng-container>
				    <ng-container *ngIf="visibilityController.note">
					    <i (click)="visibilityController.noteSwitch(VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit())"
					       [class.disabled]="VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit()"
					       [tooltip]="getGlobal('Edit')"
					       class="search-filter-action fal fa-edit" flow="left">
					    </i>
					    <i (click)="deleteNote()"
					       [class.disabled]="VCreceiptNoteTable.selectedRow === -1 || !securityHandler.canEdit()"
					       [tooltip]="getGlobal('Delete')"
					       class="search-filter-action fal fa-trash-alt" flow="left">
					    </i>
					    <!-- #AnnotationModes -->
				    </ng-container>
				    <i class="search-filter-seperator"></i>
			    </ng-container>
		    </ng-container>
	    </div>
    </div>
  </div>
</div>
